import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orders" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_search = _resolveComponent("page-search")!
  const _component_page_content = _resolveComponent("page-content")!
  const _component_page_modal = _resolveComponent("page-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_search, {
      searchFormConfig: _ctx.searchFormConfig,
      onResetBtnClick: _ctx.handleResetClick,
      onQueryBtnClick: _ctx.handleQueryClick
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onQueryBtnClick"]),
    _createVNode(_component_page_content, {
      ref: "pageContentRef",
      contentTableConfig: _ctx.contentTableConfig,
      pageName: "order",
      btnName: "新建订单",
      showExportBtn: true,
      onSeeBtnClick: _ctx.handleSeeData,
      onNewBtnClick: _ctx.handleNewData,
      onEditBtnClick: _ctx.handleEditData,
      onExportBtnClick: _ctx.handleExportData,
      onExportData: _ctx.exportData
    }, null, 8, ["contentTableConfig", "onSeeBtnClick", "onNewBtnClick", "onEditBtnClick", "onExportBtnClick", "onExportData"]),
    _createVNode(_component_page_modal, {
      ref: "pageModalRef",
      modalConfig: _ctx.ModalConfigRef,
      defaultInfo: _ctx.defaultInfo,
      rules: _ctx.rules,
      pageName: "order",
      dialogWidth: "80%"
    }, null, 8, ["modalConfig", "defaultInfo", "rules"])
  ]))
}